import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Divider, IconButton, MenuItem, ListItem, ListItemIcon, ListItemText, Popover } from "@material-ui/core";
import AccountCircle from "@material-ui/icons/AccountCircle";
import ExitIcon from "@material-ui/icons/ExitToApp";
import SettingsIcon from "@material-ui/icons/Settings";
import { useCustomClaims } from "hooks";
import { useAppContext } from "store/context";
import { Settings } from "routes";

const AccountMenu = ({ nickname }) => {
  const { firebase, user } = useAppContext();
  const {
    claims: { merchant_id },
  } = useCustomClaims(user);

  const [menuOpen, setMenuOpen] = useState(null);
  const history = useHistory();
  const [settingsOpen, setSettingsOpen] = useState(false);

  const toggleMenu = (event) => setMenuOpen(event.currentTarget);
  const closeMenu = () => setMenuOpen(null);

  const handleSignOut = async () => {
    await firebase.auth().signOut();
    history.push("/");
  };

  const toggleSettings = () => {
    setSettingsOpen(!settingsOpen);
    closeMenu();
  };

  return (
    <React.Fragment>
      <IconButton color="inherit" onClick={toggleMenu}>
        <AccountCircle />
      </IconButton>
      <Popover
        open={Boolean(menuOpen)}
        anchorEl={menuOpen}
        onClose={closeMenu}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <React.Fragment>
          <ListItem dense>
            <ListItemIcon>
              <AccountCircle />
            </ListItemIcon>
            {user ? <ListItemText primary={nickname} secondary={user.displayName} /> : null}
          </ListItem>
          <Divider />
          <MenuItem dense onClick={toggleSettings}>
            <ListItemIcon>
              <SettingsIcon />
            </ListItemIcon>
            <ListItemText primary="Settings" />
          </MenuItem>
          <MenuItem dense onClick={handleSignOut}>
            <ListItemIcon>
              <ExitIcon />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </MenuItem>
        </React.Fragment>
      </Popover>
      {settingsOpen ? <Settings open={settingsOpen} handleClose={toggleSettings} merchant_id={merchant_id} /> : null}
    </React.Fragment>
  );
};

export default AccountMenu;
